function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35 0C28.0777 0 21.3108 2.05271 15.5551 5.89856C9.79933 9.74441 5.3133 15.2107 2.66423 21.6061C0.015165 28.0015 -0.677952 35.0388 0.672531 41.8282C2.02301 48.6175 5.35644 54.8539 10.2513 59.7487C15.1461 64.6436 21.3825 67.977 28.1718 69.3275C34.9612 70.6779 41.9985 69.9848 48.3939 67.3358C54.7893 64.6867 60.2556 60.2007 64.1014 54.4449C67.9473 48.6892 70 41.9223 70 35C69.9902 25.7204 66.2996 16.8237 59.7379 10.2621C53.1763 3.70043 44.2796 0.00979939 35 0ZM50.3663 28.8279L31.5202 47.674C31.2702 47.9243 30.9732 48.1229 30.6464 48.2584C30.3195 48.3939 29.9692 48.4636 29.6154 48.4636C29.2616 48.4636 28.9112 48.3939 28.5844 48.2584C28.2576 48.1229 27.9606 47.9243 27.7106 47.674L19.6337 39.5971C19.1285 39.0919 18.8447 38.4067 18.8447 37.6923C18.8447 36.9779 19.1285 36.2927 19.6337 35.7875C20.1388 35.2823 20.824 34.9985 21.5385 34.9985C22.2529 34.9985 22.9381 35.2823 23.4433 35.7875L29.6154 41.963L46.5567 25.0183C46.8069 24.7681 47.1038 24.5697 47.4307 24.4343C47.7575 24.2989 48.1078 24.2293 48.4615 24.2293C48.8153 24.2293 49.1656 24.2989 49.4924 24.4343C49.8192 24.5697 50.1162 24.7681 50.3663 25.0183C50.6165 25.2684 50.8149 25.5654 50.9503 25.8922C51.0857 26.219 51.1553 26.5693 51.1553 26.9231C51.1553 27.2768 51.0857 27.6271 50.9503 27.9539C50.8149 28.2808 50.6165 28.5777 50.3663 28.8279Z",
    fill: "#66C497",
    style: {
      fill: "#66C497",
      fill: "color(display-p3 0.4000 0.7686 0.5922)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.062658deccc91dbbf15ddf2c4a77f202.svg";
export { ForwardRef as ReactComponent };